import defaultTokens, {
  type LinkTokens,
} from '@agria/theme/src/components/link/tokens';

const tokens: LinkTokens = {
  ...defaultTokens,
  circleBorderColor: 'brandOne100',
  circleHoverBorderColor: 'brandOne100',
  hoverColour: 'brandOne100',
};

export default tokens;
